"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateName = validateName;
exports.validateUniqueName = validateUniqueName;
exports.validateCalloutHeading = validateCalloutHeading;
exports.validateCtaText = validateCtaText;
exports.validateCalloutDescription = validateCalloutDescription;
exports.validateColor = validateColor;
exports.validateRedirectOption = validateRedirectOption;
exports.validateKickbackEmails = validateKickbackEmails;
exports.validateEditableDyno = validateEditableDyno;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _DynoEditor = require("lead-flows-ui/constants/DynoEditor");

var _RedirectButtonType = _interopRequireDefault(require("lead-flows-ui/constants/RedirectButtonType"));

var _ValidationUtils = require("lead-flows-ui/utils/ValidationUtils");

var _DynoValidation = require("lead-flows-ui/constants/DynoValidation");

function validateName(_ref) {
  var name = _ref.name;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var step = _DynoEditor.STEPS.OPTIONS;
  var errors = [];

  if (!name || name.length < _DynoValidation.MIN_NAME_LENGTH) {
    errors.push(['name', prefix + "nameFieldRequired", step]);
  } else if (name && name.length > _DynoValidation.MAX_NAME_LENGTH) {
    errors.push(['name', prefix + "nameExceededMaxLength", step]);
  }

  return errors;
}

function validateUniqueName(validation) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var step = _DynoEditor.STEPS.OPTIONS;
  var errors = [];

  if (validation.options && validation.options.name && validation.options.name.indexOf('duplicatedName') > -1) {
    errors.push(['name', prefix + "nameDuplicated", step]);
  }

  return errors;
}

function validateCalloutHeading(_ref2) {
  var heading = _ref2.heading;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var step = _DynoEditor.STEPS.CALLOUT;
  var errors = [];

  if (!heading || heading.trim().length === 0) {
    errors.push(['heading', prefix + "callOutFieldRequired", step]);
  } else if (heading && heading.length > _DynoValidation.HEADING_MAX_LENGTH) {
    errors.push(['heading', prefix + "exceededMaxHeaderLength", step, {
      HEADER_MAX_LENGTH: _DynoValidation.HEADING_MAX_LENGTH
    }]);
  }

  return errors;
}

function validateCtaText(_ref3) {
  var cta = _ref3.cta;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var step = _DynoEditor.STEPS.CALLOUT;
  var errors = [];

  if (!cta || cta.trim().length === 0) {
    errors.push(['cta', prefix + "buttonTextFieldRequired", step]);
  } else if (cta.length > _DynoValidation.CTA_TEXT_MAX_LENGTH) {
    errors.push(['cta', prefix + "exceededMaxCTALength", step]);
  }

  return errors;
}

function validateCalloutDescription(_ref4) {
  var description = _ref4.description;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var step = _DynoEditor.STEPS.CALLOUT;
  var errors = [];

  if (description && description.length > _DynoValidation.DESCRIPTION_MAX_LENGTH) {
    errors.push(['description', prefix + "descriptionExceedsMaxLength", step]);
  }

  return errors;
}

function validateColor(_ref5) {
  var color = _ref5.color;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var step = _DynoEditor.STEPS.CALLOUT;
  var errors = [];

  if (color && !_DynoValidation.HEX_REGEX.test(color)) {
    errors.push(['color', prefix + "selectHexColor", step]);
  }

  return errors;
}

function validateRedirectOption(_ref6) {
  var redirectButtonType = _ref6.redirectButtonType,
      redirectUrl = _ref6.redirectUrl;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var error = null;
  var step = _DynoEditor.STEPS.THANKS;

  switch (redirectButtonType) {
    case _RedirectButtonType.default.HTTP_LINK:
      if (!redirectUrl) {
        error = 'urlRequired';
      } else if (!(0, _ValidationUtils.isValidUrl)(redirectUrl, false)) {
        error = 'urlMustBeValid';
      }

      break;

    case _RedirectButtonType.default.COS_PAGE_LINK:
      if (!redirectUrl) {
        error = 'cosUrlRequired';
      }

      break;

    case _RedirectButtonType.default.FILE_DOWNLOAD:
      if (!redirectUrl) {
        error = 'fileUrlRequired';
      }

      break;

    case _RedirectButtonType.default.MEETINGS_LINK:
      if (!redirectUrl) {
        error = 'meetingUrlRequired';
      }

      break;

    default:
      break;
  }

  return error ? [['redirectUrl', prefix + "." + error, step]] : [];
}

function validateKickbackEmails(_ref7) {
  var kickbackEmails = _ref7.kickbackEmails;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var errors = [];
  var step = _DynoEditor.STEPS.KICKBACK;

  if (kickbackEmails) {
    kickbackEmails.forEach(function (email, idx) {
      if (!email.emailData.emailSenderUserId) {
        errors.push(["emailSenderUserId_" + idx, prefix + "selectVerifiedUser", step]);
      }

      if (!email.emailData.emailSubjectLine) {
        errors.push(["emailSubjectLine_" + idx, prefix + "includeSubjectLine", step]);
      }

      if (!email.emailData.emailMessageHtml) {
        errors.push(["emailMessageHtml_" + idx, prefix + "includeEmailMessage", step]);
      }
    });
  }

  return errors;
}

function validateEditableDyno(dynosEditor) {
  var editableDyno = dynosEditor.editableDyno,
      validation = dynosEditor.validation;
  var errors = [].concat((0, _toConsumableArray2.default)(validateName(editableDyno)), (0, _toConsumableArray2.default)(validateUniqueName(validation)), (0, _toConsumableArray2.default)(validateCalloutHeading(editableDyno)), (0, _toConsumableArray2.default)(validateCtaText(editableDyno)), (0, _toConsumableArray2.default)(validateCalloutDescription(editableDyno)), (0, _toConsumableArray2.default)(validateColor(editableDyno)), (0, _toConsumableArray2.default)(validateRedirectOption(editableDyno)), (0, _toConsumableArray2.default)(validateKickbackEmails(editableDyno)));
  return errors;
}